export default {
  SERVICE_URL: '?pogodbeni-servisi',
}